import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import marquee from "vanilla-marquee";

document.addEventListener('DOMContentLoaded', function ()
{
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });

    const swiperHero = new Swiper('.swiper-hero', {
        loop: true,
/*        autoplay: true,
        speed: 1500,*/
        pagination: {
            el: ".swiper-pagination-hero",
            type: "fraction",
        },
        navigation: {
            nextEl: '.swiper-button-next-hero',
            prevEl: '.swiper-button-prev-hero',
        },
    });

    const swiperVentajas = new Swiper('.swiper-ventajas', {
        loop: true,
        autoplay: true,
        speed: 2000,
        navigation: {
            nextEl: '.swiper-button-next-ventajas',
            prevEl: '.swiper-button-prev-ventajas',
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1280: {
                slidesPerView: 5,
                spaceBetween: 0,
            },
            1920: {
                slidesPerView: 5,
            },
        }
    });

    const swiperNoticias = new Swiper('.swiper-noticias', {
        loop: true,
        autoplay: true,
        speed: 2000,
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 44
            },
            1280: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1920: {
                slidesPerView: 3,
                spaceBetween: 35,
            },
        }
    });

    const swiperSoluciones = new Swiper('.swiper-soluciones', {
        loop: true,
        // autoplay: true,
        speed: 2000,
        navigation: {
            nextEl: '.swiper-button-next-soluciones',
            prevEl: '.swiper-button-prev-soluciones',
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            1280: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1920: {
                slidesPerView: 3,
                spaceBetween: 35,
            },
        }
    });

    const marqueeSoluciones = document.getElementById('marquee-soluciones');

    const swiperReviewsEl = document.querySelector('.swiper-reviews');
    if (swiperReviewsEl)
    {
        const swiperReviews = new Swiper(swiperReviewsEl, {
            loop: true,
            rewind: true,
            watchOverflow: true,
            autoplay: true,
            speed: 2000,
            pagination: {
                el: ".swiper-pagination-reviews",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                },
                640: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
            }
        });

    }

    new marquee(marqueeSoluciones,
        {
            css3easing: 'ease-in',
            duplicated: true,
            direction: 'right',
            startVisible: true,
            speed: 200,
        }
    )


/*    const swiperSoldOutProjectsEl = document.querySelector('.swiper-soldout-projects');
    if (swiperSoldOutProjectsEl) {
        const soldOutProjectsCount = parseInt(swiperSoldOutProjectsEl.dataset.soldoutCount);
        const maxSlidesPerView = 4;
        const isSafeToLoop = soldOutProjectsCount > maxSlidesPerView;

        const swiperSoldOutProjects = new Swiper('.swiper-soldout-projects', {
            modules: [Autoplay, Navigation],
            mousewheel: true,
            loop: isSafeToLoop,
            rewind: !isSafeToLoop,
            watchOverflow: true,
            navigation: {
                nextEl: '.swiper-button-next-soldout-projects',
                prevEl: '.swiper-button-prev-soldout-projects',
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
                640: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                },
                1280: {
                    slidesPerView: getSlidesPerView(soldOutProjectsCount, 3, .8, 5),
                    spaceBetween: 20,
                },
                1536: {
                    slidesPerView: getSlidesPerView(soldOutProjectsCount, 5, .05, 5),
                    spaceBetween: 20,
                }
            }
        });
    } else {
        console.warn('⚠️ Elemento Swiper No Encontrado');
    }*/

    function getSlidesPerView(count, full, peek, threshold = full + 1) {
        if (count >= threshold) return full + peek;
        return Math.min(count, full);
    }

});
